import { HolderOutlined, StopTwoTone } from "@ant-design/icons";
import { useDraggable } from "@dnd-kit/core";
import React from "react";
import { Field } from "../../../containers/QueryBuilder/types/Field";
import styles from './FieldItem.module.scss';

export interface FieldItemProps {
    id: string
    field: Field
    isOverlay?: boolean
}

export const FieldItem = ({ id, field, isOverlay }: FieldItemProps) => {
    const { isDragging, over } = useDraggable({
        id: `draggable-${field.code}`,
        data: { from: id, field: field },
    })

    const isOverAndDisabled =
        isDragging && over && over.data.current && !over.data.current.enabled

    return (
        <div
            className={styles.field}
            style={
                isOverlay
                    ? {
                        boxShadow: "0 3px 6px rgba(0, 0, 0, 0.25)", // tighter, less blur
                        zIndex: 9999,
                    }
                    : undefined
            }
            data-testid={field.code}
        >
            <HolderOutlined style={{ fontSize: '16px' }} />
            <StopTwoTone
                className={isOverAndDisabled ? styles.no : styles.yes}
                twoToneColor="#eb2f4e"
            />
            <span className={styles.name}>{field.name}</span>
        </div>
    )
}